import { compose, withHandlers, withProps } from 'recompose';
import { withTranslation } from 'react-i18next';

import AddressSuggestionItem from 'components/AddressModal/components/AddressSuggestionItem/component';

const enhance = compose(
  withTranslation('StopAddress'),
  withHandlers({
    handleClick:
      ({ value, onClick }) =>
      () => {
        onClick({ value });
      },
  }),
  withProps(({ value }) => ({
    address: value,
  }))
);

export default enhance(AddressSuggestionItem);
